import React from 'react';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';

const accents = {
  red: 'glass-stat--red',
  blue: 'glass-stat--blue',
  green: 'glass-stat--green',
  gold: 'glass-stat--gold',
  navy: 'glass-stat--navy',
};

export const GlassStatCard = ({
  title,
  value,
  subtitle,
  icon,
  accent = 'blue',
  trend,
  className,
}) => {
  return (
    <div className={clsx('glass-stat', accents[accent], className)}>
      <div className="glass-stat__top">
        <p className="glass-stat__label">{title}</p>
        {icon && (
          <div className="glass-stat__icon-ring">
            <SafeIcon icon={icon} className="glass-stat__icon" />
          </div>
        )}
      </div>
      <p className="glass-stat__value">{value}</p>
      {(subtitle || trend) && (
        <div className="glass-stat__bottom">
          {subtitle && <span className="glass-stat__sub">{subtitle}</span>}
          {trend && (
            <span className={clsx(
              'glass-stat__trend',
              trend > 0 ? 'glass-stat__trend--up' : 'glass-stat__trend--down'
            )}>
              {trend > 0 ? '+' : ''}{trend}%
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default GlassStatCard;
